import React from 'react'

export const IconChat: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0744 9.00214C19.8044 1.41214 16.5344 -0.347858 8.9944 1.92214C1.4544 4.19214 -0.355599 7.46214 1.9144 15.0021C4.1844 22.5421 7.4544 24.3521 14.9944 22.0821C22.5344 19.8121 24.3444 16.5421 22.0744 9.00214Z M12.5645 5.99219L16.1445 16.3922 M7.84473 7.61133L11.4247 18.0113 M16.3844 7.85156L5.98438 11.4316 M18.0045 12.5723L7.60449 16.1523"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
